import type { IProductFeedbackAnswerLoadedOrPending } from '@lib/core/products/slices/productFeedback';

export type TQuestionAnswersCheck = {
  choices?: string[];
  answers?: IProductFeedbackAnswerLoadedOrPending[];
};

export const isQuestionAnswersLoaded = (question?: TQuestionAnswersCheck) =>
  !!question?.choices?.length &&
  question.choices.length ===
    question.answers?.filter(answer => !('urlToBeLoaded' in answer) || 'isRequestFailed' in answer).length;

export const areAllQuestionsAnswersLoaded = (questions?: TQuestionAnswersCheck[]) =>
  !!questions?.length && questions.every(isQuestionAnswersLoaded);
